module.exports = require("stream");


//////////////////
// WEBPACK FOOTER
// external "stream"
// module id = 53
// module chunks = 0